import {PURCHASE_STATUS} from '../actions/index';
export default function (state = null, action) {

  switch (action.type) {
    case PURCHASE_STATUS:
      return action.payload.data;
    default:
      break;
  }
  return state;
}
